import { makeStyles } from "tss-react/mui";

const useStyle = makeStyles()((theme) => ({
  outlinedInput: {
    maxWidth: "200px",
    width: "100%",
    height: "40px",
    "& input::-webkit-input-placeholder": {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "400",
    },
  },
  closeIcon: {
    height: "100%",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    color: theme.palette.primary.main,
  },
  connected: {
    color: "green",
  },
  heading: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
  },
  tableContainer: {
    marginTop: "30px",
    maxHeight: "calc(100vh - 275px)",
  },
  rowCell: {
    padding: 0,
    border: "none",
  },
  phoneIcon: {
    height: "40px",
    width: "40px",
    backgroundColor: "#EAE9E9",
    border: "1px solid #9999993b",
    color: "#999999",
    borderRadius: "3px",
  },
  rowCellProfileBox: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    gap: "10px",
  },
  rowCellControlBox: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "60px",
  },
  numberText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#999999",
  },
  addIcon: {
    fontSize: "15px",
    marginRight: "6.8px",
  },
  buttonBox: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  subheader: {
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "16px",
    color: "#272525",
  },
  cardContent: {
    padding: 0,
    marginTop: "20px",
  },
  formikBox: {
    display: "flex",
    flexDirections: "row",
    alignItems: "center",
    justifyContent: "flex-start",
  },
  addButton: {
    fontSize: "12px",
    fontWeight: "500",
    marginLeft: 10,
    [theme.breakpoints.down("sm")]: {
      marginTop: 10,
      marginLeft: 0,
    },
  },
  tableStyle: {
    width: "100%;",
    borderCollapse: "separate",
    borderSpacing: "0 15px",
  },
  phoneNumberStyle: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: "0px",
    color: "#272525",
  },
  disconnectButton: {
    color: "#FF1B1B",
    backgroundColor: "#FF1B1B3D",
    border: "none",
    borderRadius: "5px",
    height: "31px",
    textTransform: "capitalize",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "100%",
    letterSpacing: 0,
    transition: "background-color 0.3s ease",
    "&:hover": {
      backgroundColor: "#FF1B1B1A",
      border: "none",
    },
  },
}));

export default useStyle;
